import React from "react";
import {Form, InputNumber, Tag} from "antd";

const inputStyle = {
    width: '50%',
    marginRight: '16px'
}

const StockWarehouseQuantity = ({
                                    warehouseName,
                                    warehouseId,
                                    updateBulkList,
                                    initialQuantity = undefined,
                                    recordId = undefined
                                }) => {

    const handleQuantityChange = ({target}) => {
        updateBulkList(+target.value, warehouseId, {recordId: recordId})
    }

    return (
        <React.Fragment>
            <Form.Item label={'Adet'}>
                <InputNumber
                    onBlur={handleQuantityChange}
                    step={0.1}
                    min={0}
                    style={inputStyle}
                    defaultValue={initialQuantity}
                />
                <Tag color="geekblue">{warehouseName}</Tag>
            </Form.Item>
        </React.Fragment>
    )
}
export default StockWarehouseQuantity